import styled from 'styled-components';

export const ReadMoreContainer = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0px 0px 12px 0px !important;
  }
  width: 100%;
`;

export const LinkContainer = styled.div`
  padding-top: 24px;
  gap: 8px;

  :hover {
    cursor: pointer;
  }

  @media print {
    visibility: hidden;
  }
`;

export const FullTextContainer = styled.div<{ isVisible?: boolean }>`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  @media print {
    visibility: visible;
  }
`;

export const IntroTextContainer = styled.div<{ isVisible?: boolean }>`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  @media print {
    visibility: hidden;
  }
`;

export const ContentContainer = styled.div`
  overflow: auto;
  transition: max-height 0.4s ease;
  font-size: var(--font-size-body-1);
  font-family: var(--font-family-body);
  font-feature-settings: var(--font-feature-settings-body);
  font-weight: var(--font-weight-body-1);
  letter-spacing: var(--letter-spacing-body-1);
  line-height: var(--line-height-body-1);
  text-transform: var(--text-transform-body);

  & h1 {
    font-size: var(--font-size-header-4);
    font-family: var(--font-family-header);
    font-feature-settings: var(--font-feature-settings-header);
    font-weight: var(--font-weight-header-4);
    letter-spacing: var(--letter-spacing-header-4);
    line-height: var(--line-height-header-4);
    text-transform: var(--text-transform-header);
    white-space: break-spaces;
    overflow-wrap: break-word;
  }

  & h2 {
    font-size: var(--font-size-subtitle-1);
    font-family: var(--font-family-subtitle);
    font-feature-settings: var(--font-feature-settings-subtitle);
    font-weight: var(--font-weight-subtitle-1);
    letter-spacing: var(--letter-spacing-subtitle-1);
    line-height: var(--line-height-subtitle-1);
    text-transform: var(--text-transform-subtitle);
    white-space: break-spaces;
    overflow-wrap: break-word;
  }

  & em {
    font-family: var(--font-family-body-italics);
  }

  & u {
    font-size: var(--font-size-body-1);
    font-family: var(--font-family-body);
  }
  @media print {
    visibility: visible;
    max-height: 900px !important;
  }
`;
